webpackJsonp([213720915766396],{

/***/ 137:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Project":"src-components-Project----Project-module---Project---2miAy","Head":"src-components-Project----Project-module---Head---23TP7","Skills":"src-components-Project----Project-module---Skills---Umb25","Title":"src-components-Project----Project-module---Title---2WGHd","Link":"src-components-Project----Project-module---Link---12_7r","date":"src-components-Project----Project-module---date---HjpJn"};

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProjectModule = __webpack_require__(137);
	
	var _ProjectModule2 = _interopRequireDefault(_ProjectModule);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Tag = __webpack_require__(105);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Typography = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Project = function Project(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      skills = _ref.skills,
	      url = _ref.url,
	      date = _ref.date;
	  return _react2.default.createElement(
	    'div',
	    { className: _ProjectModule2.default.Project },
	    _react2.default.createElement(
	      'div',
	      { className: _ProjectModule2.default.Head },
	      _react2.default.createElement(_Typography.Title, { h5: true, flat: true, title: title, weight: 600, size: '34%', primary: true }),
	      _react2.default.createElement(
	        'div',
	        { className: _ProjectModule2.default.Skills },
	        skills.map(function (skill) {
	          return _react2.default.createElement(_Tag2.default, { key: skill, title: skill });
	        })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: _ProjectModule2.default.date },
	        date
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _ProjectModule2.default.Body },
	      _react2.default.createElement(
	        _Typography.Text,
	        null,
	        description
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { title: url, className: _ProjectModule2.default.Link },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: url },
	        '\u21B3'
	      )
	    )
	  );
	};
	
	Project.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  skills: _propTypes2.default.array.isRequired,
	  url: _propTypes2.default.string.isRequired
	};
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Tag":"src-components-Tag----Tag-module---Tag---nFUgo"};

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TagModule = __webpack_require__(138);
	
	var _TagModule2 = _interopRequireDefault(_TagModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tag = function Tag(_ref) {
	  var title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: _TagModule2.default.Tag },
	    title
	  );
	};
	
	Tag.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = Tag;
	module.exports = exports['default'];

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Project = __webpack_require__(104);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _Hero = __webpack_require__(23);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Container = __webpack_require__(56);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Hero2.default, { title: 'Projects' }),
	    _react2.default.createElement(
	      _Container2.default,
	      { padding: true },
	      data.projects.edges.map(function (project) {
	        return _react2.default.createElement(_Project2.default, {
	          key: project.node.frontmatter.url,
	          title: project.node.frontmatter.title,
	          skills: project.node.frontmatter.skills,
	          description: project.node.frontmatter.description,
	          url: project.node.fields.slug
	        });
	      })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-e9d507a0de7670331b20.js